import { backendGet, backendPost } from '../lib/backendClient';

export async function createMercadoPagoPreference(orderId) {
  return await backendPost('/api/payments/mercadopago/preference', {
    order_id: orderId,
  });
}

export async function getMercadoPagoConfig() {
  return await backendGet('/api/payments/mercadopago/config');
}

export async function createMercadoPagoInlinePayment(orderId, cardPayload) {
  return await backendPost('/api/payments/mercadopago/inline/pay', {
    order_id: orderId,
    card: cardPayload || null,
  });
}

export async function listMercadoPagoSavedCards() {
  return await backendGet('/api/payments/mercadopago/saved-cards');
}

export async function startPaymentCheckout(orderId) {
  return await backendPost('/api/payments/checkout/start', {
    order_id: orderId,
  });
}

export async function getVoucherCheckoutStatus(orderId) {
  return await backendGet(`/api/payments/voucher/status/${orderId}`);
}
